<template>
  <div class="search filter-container">
    <el-form ref="form" :model="searchForm" :inline="true" label-width="100px">
      <el-form-item label="通知内容">
        <el-input
          v-model="searchForm.messageContent"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="searchForm.messageType" placeholder="请选择" filterable clearable>
          <el-option
            v-for="(item, index) in messageTypeList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="接收时间">
        <el-date-picker
          v-model="searchForm.createTime"
          type="daterange"
          range-separator="-"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:300px"
        >
        </el-date-picker>
      </el-form-item>
      <el-button
        type="primary"
        size="small"
        @click="handleSearch"
        >查询</el-button
      >
      <el-button type="primary" plain @click="handleResetQuery"
        >重置</el-button
      >
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchForm: {
        noticeContent: "",
        messageType: "",
        messageStatus: "",
        createTime: ""
      },
      messageTypeList: [
        {
          label: "驳回",
          value: 0
        },
        {
          label: "已拒赔",
          value: 1
        }
      ]
    };
  },
  async mounted() {},
  methods: {
    handleSearch() {
      this.$emit("handleSearch", this.searchForm);
    },
    // 重置查询条件
    handleResetQuery() {
      this.searchForm = Object.assign({}, this.$options.data().searchForm);
      this.handleSearch();
    }
  }
};
</script>
